import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

function UserAudit() {
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const search = searchParams.get("search");
    const page = parseInt(searchParams.get("page")) || 1;

    if (search) {
      setSearchText(search);
    }
    setCurrentPage(page);
    fetchUsers(search, page);
  }, [searchParams]);

  const fetchUsers = async (search = "", page = 1) => {
    try {
      setLoading(true);

      const token = localStorage.getItem("accessToken");
      if (!token) {
        navigate("/");
        return;
      }

      let url = `${apiUrl}get-users-list?page=${page}&limit=${itemsPerPage}`;

      if (search) {
        url += `&searchTerm=${encodeURIComponent(search)}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      console.log(result.data.users, "users");

      setUsers(result.data.users || []);

      if (result.data.totalCount) {
        setTotalPages(Math.ceil(result.data.totalCount / itemsPerPage));
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (searchText) params.append("search", searchText);
    params.append("page", "1");
    navigate(`?${params.toString()}`);
  };

  const handleClear = () => {
    setSearchText("");
    navigate("?page=1");
  };

  const handlePageChange = (newPage) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", newPage.toString());
    navigate(`?${params.toString()}`);
  };

  const renderPagination = () => {
    return (
      <div className="d-flex justify-content-between align-items-center mt-4">
        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <div className="text-center">
          Page {currentPage} of {totalPages}
        </div>

        <button
          className="btn btn-outline-secondary px-4 rounded"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="dashboard-title mb-3">
        <h1>User Audit</h1>
      </div>
      <div className="row mb-3 clearfix">
        <div className="col-12 col-lg-12">
          <div className="filters">
            <div className="row gx-2 clearfix">
              <div className="col-12 col-lg-4 col-xl-5">
                <div>
                  <input
                    type="text"
                    className="form-control"
                    id="search"
                    placeholder="Search by Name, Email"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-12 col-lg-3 col-xl-2">
                <button
                  className="btn btn-secondary w-100"
                  onClick={handleSearch}
                >
                  Search
                </button>
              </div>
              <div className="col-12 col-lg-3 col-xl-2">
                <button className="btn btn-light w-100" onClick={handleClear}>
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12 col-xl-12">
          <div className="table-container">
            {loading ? (
              <div className="text-center p-4">Loading...</div>
            ) : (
              <>
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user, index) => (
                      <tr key={user.id}>
                        <th scope="row">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </th>
                        <td>{user.userName}</td>
                        <td>{user.email}</td>
                        <td>
                          <a href={`/user-audit-details/${user.id}`}>
                            <i className="bi bi-eye me-2"></i>
                          </a>
                        </td>
                      </tr>
                    ))}
                    {users.length === 0 && (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {users.length > 0 && renderPagination()}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default UserAudit;
